import React, { useEffect, useState } from "react";
import Select from "react-select";

export default function AgencyFilter({
  onSelectAgency,
  reset,
  borderTrue,
  ismultiple = false,
  preSelectedValues,
  isdisabled = false,
  agencyList = [],
}) {
  const [selectedAgency, setSelectedAgency] = useState(
    ismultiple ? [] : null
  );
  const [list, setList] = useState([]);

  // Load agency list from props
  useEffect(() => {
    if (Array.isArray(agencyList) && agencyList.length > 0) {
      setList(agencyList);
    }
  }, [agencyList]);

  // Handle pre-selected values
  useEffect(() => {
    if (
      preSelectedValues &&
      list.length > 0 &&
      (ismultiple ? selectedAgency.length === 0 : !selectedAgency)
    ) {
      const preSelectedOptions = list.filter((option) =>
        ismultiple
          ? preSelectedValues.includes(option.value)
          : option.value === preSelectedValues
      );
      setSelectedAgency(ismultiple ? preSelectedOptions : preSelectedOptions[0] || null);
    }
  }, [list, preSelectedValues, ismultiple]);

  // Reset handler
  useEffect(() => {
    if (reset) {
      setSelectedAgency(ismultiple ? [] : null);
    }
  }, [reset]);

  const handleChange = (selected) => {
    setSelectedAgency(selected);
    if (ismultiple) {
      onSelectAgency(selected.map((option) => option.value));
    } else {
      onSelectAgency(selected?.value || "");
    }
  };

  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          borderTop: !borderTrue && "none",
          borderLeft: !borderTrue && "none",
          borderRight: !borderTrue && "none",
          boxShadow: borderTrue && "none",
          "&:hover": {
            borderColor: "#2684FF",
          },
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: "#a71e1e",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#6c757d",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          borderRadius: 0,
        }),
      }}
      options={list}
      value={selectedAgency}
      onChange={handleChange}
      placeholder=" AGENCY"
      isMulti={ismultiple}
      isSearchable
      isDisabled={isdisabled}
    />
  );
}
